export const SEARCH_COMMON_URL_PARAMS = "pageSection";
export const SIGNAL_URL_PARAMS = "digestType&digestDate&signalSubType&template:email_signals&domain";
export const SIGNAL_URL_PARAMS_WITH_ID = `signalId&${SIGNAL_URL_PARAMS}`;

/* ---- Router state ID's ---- */

// Defined in app/common (single source) so cross-zone route constants can build on it.
export { SI_ROOT_ROUTE } from "app/common/constants/ad-intelligence-routes";
import { SI_ROOT_ROUTE } from "app/common/constants/ad-intelligence-routes";

export const HOME_PAGE_ROUTE = `${SI_ROOT_ROUTE}-home`;
export const MY_LISTS_PAGE_ROUTE = `${SI_ROOT_ROUTE}-myLists`;
export const STATIC_LIST_PAGE_ROUTE = `${MY_LISTS_PAGE_ROUTE}-staticList`;
export const CRM_LIST_PAGE_ROUTE = `${MY_LISTS_PAGE_ROUTE}-crmList`;

export const CRM_LIST_MAIN_PAGE_ROUTE = `${MY_LISTS_PAGE_ROUTE}-mainCrmList`;

export const ENRICHMENT_PAGE_ROUTE = `${SI_ROOT_ROUTE}-enrichment`;
export const SCORE_SETTINGS_PAGE_ROUTE = `${SI_ROOT_ROUTE}-score-settings`;
export const DOWNLOAD_EXTENSION_PAGE_ROUTE = `${SI_ROOT_ROUTE}-download-extension`;
export const PREMIUM_FEATURES_PAGE_ROUTE = `${SI_ROOT_ROUTE}-premium-features`;

export const MANAGEMENT_ROUTE = `${SI_ROOT_ROUTE}-management`;
export const ACCOUNT_SIGNALS_MANAGEMENT_PAGE_ROUTE = `${MANAGEMENT_ROUTE}-signals`;
export const INTENT_SIGNALS_MANAGEMENT_PAGE_ROUTE = `${MANAGEMENT_ROUTE}-intentSignals`;
export const INTENT_SIGNALS_MANAGEMENT_INTRO_PAGE_ROUTE = `${MANAGEMENT_ROUTE}-intentSignals-intro`;

export const SI_COMPANY_ANALYSIS_BASE_ROUTE = `${SI_ROOT_ROUTE}-company-analysis`;

export const COMPANY_ANALYSIS_ROOT = `${SI_ROOT_ROUTE}-root-company-analysis-abstract`;
export const COMPANY_ANALYSIS_KEY = `${SI_COMPANY_ANALYSIS_BASE_ROUTE}-abstract`;

export const COMPANY_ANALYSIS_HOME = `${SI_COMPANY_ANALYSIS_BASE_ROUTE}-home`;
export const COMPANY_ANALYSIS_OVERVIEW = `${SI_COMPANY_ANALYSIS_BASE_ROUTE}-overview`;
export const COMPANY_ANALYSIS_CONTACTS = `${SI_COMPANY_ANALYSIS_BASE_ROUTE}-contacts`;
export const COMPANY_ANALYSIS_SIGNALS = `${SI_COMPANY_ANALYSIS_BASE_ROUTE}-signals`;
export const COMPANY_ANALYSIS_DIGITAL_ASSETS = `${SI_COMPANY_ANALYSIS_BASE_ROUTE}-digital-assets`;
export const COMPANY_ANALYSIS_TECHNOLOGIES = `${SI_COMPANY_ANALYSIS_BASE_ROUTE}-technologies`;
export const COMPANY_ANALYSIS_COMPETITORS = `${SI_COMPANY_ANALYSIS_BASE_ROUTE}-competitors`;

export const SI_COMPANY_ANALYSIS_TAB_ROUTES = [
    COMPANY_ANALYSIS_OVERVIEW,
    COMPANY_ANALYSIS_CONTACTS,
    COMPANY_ANALYSIS_SIGNALS,
    COMPANY_ANALYSIS_DIGITAL_ASSETS,
    COMPANY_ANALYSIS_TECHNOLOGIES,
    COMPANY_ANALYSIS_COMPETITORS,
];

export const WEBSITE_ANALYSIS_ROOT = `${SI_ROOT_ROUTE}-accountreview_website`;
export const WEBSITE_ANALYSIS_PERFORMANCE = `accountreview_website_overview_websiteperformance`;
export const WEBSITE_ANALYSIS_TECHNOLOGIES = `accountreview_website_technologies`;
export const WEBSITE_ANALYSIS_COMPETITORS = `accountreview_website_competitivelandscape`;
export const WEBSITE_ANALYSIS_TRAFFIC_ENGAGEMENT = `accountreview_website_trafficandengagement`;
export const WEBSITE_ANALYSIS_GEOGRAPHY = `accountreview_website_audience_geography`;
export const WEBSITE_ANALYSIS_SUBDOMAINS = `accountreview_website_subdomains`;
export const WEBSITE_ANALYSIS_PAGES = `accountreview_website_website_structure_pages`;
export const WEBSITE_ANALYSIS_FOLDERS = `accountreview_website_website_structure_folders`;
export const WEBSITE_ANALYSIS_DEMOGRAPHICS = `accountreview_website_audience_demographics`;
export const WEBSITE_ANALYSIS_AUDIENCE_INTERESTS = `accountreview_website_audience_interests`;

export const WEBSITE_ANALYSIS_MARKETING_CHANNELS = `accountreview_website_marketingchannels`;
export const WEBSITE_ANALYSIS_MARKETING_CHANNELS_BETA = `accountreview_website_marketingchannels_beta`;
export const WEBSITE_ANALYSIS_MARKETING_SEARCH_OVERVIEW = `accountreview_website_search_overview`;
export const WEBSITE_ANALYSIS_MARKETING_KEYWORDS = `accountreview_website_search_keyword`;
export const WEBSITE_ANALYSIS_MARKETING_SEARCH_COMPETITORS = `accountreview_website_search_organic_competitors`;
export const WEBSITE_ANALYSIS_MARKETING_SEARCH_ADS = `accountreview_website_search_ads`;
export const WEBSITE_ANALYSIS_MARKETING_REFERRAL_INCOMING = `accountreview_website_referrals_incomingtraffic`;
export const WEBSITE_ANALYSIS_MARKETING_REFERRAL_OUTGOING = `accountreview_website_outgoingtraffic`;
export const WEBSITE_ANALYSIS_MARKETING_DISPLAY_OVERVIEW = `accountreview_website_display_overview`;
export const WEBSITE_ANALYSIS_MARKETING_PUBLISHER_OVERVIEW = `accountreview_website_publisher_overview`;
export const WEBSITE_ANALYSIS_MARKETING_DISPLAY_AD_NETWORKS = `accountreview_website_display_ad_networks`;
export const WEBSITE_ANALYSIS_MARKETING_SOCIAL_OVERVIEW = `accountreview_website_social_overview`;

export const SI_WEBSITE_ANALYSIS_TAB_ROUTES = [
    WEBSITE_ANALYSIS_PERFORMANCE,
    WEBSITE_ANALYSIS_TECHNOLOGIES,
    WEBSITE_ANALYSIS_COMPETITORS,
    WEBSITE_ANALYSIS_TRAFFIC_ENGAGEMENT,
    WEBSITE_ANALYSIS_GEOGRAPHY,
    WEBSITE_ANALYSIS_SUBDOMAINS,
    WEBSITE_ANALYSIS_PAGES,
    WEBSITE_ANALYSIS_FOLDERS,
    WEBSITE_ANALYSIS_DEMOGRAPHICS,
    WEBSITE_ANALYSIS_AUDIENCE_INTERESTS,
    WEBSITE_ANALYSIS_MARKETING_CHANNELS,
    WEBSITE_ANALYSIS_MARKETING_CHANNELS_BETA,
    WEBSITE_ANALYSIS_MARKETING_SEARCH_OVERVIEW,
    WEBSITE_ANALYSIS_MARKETING_KEYWORDS,
    WEBSITE_ANALYSIS_MARKETING_SEARCH_COMPETITORS,
    WEBSITE_ANALYSIS_MARKETING_SEARCH_ADS,
    WEBSITE_ANALYSIS_MARKETING_REFERRAL_INCOMING,
    WEBSITE_ANALYSIS_MARKETING_REFERRAL_OUTGOING,
    WEBSITE_ANALYSIS_MARKETING_DISPLAY_OVERVIEW,
    WEBSITE_ANALYSIS_MARKETING_PUBLISHER_OVERVIEW,
    WEBSITE_ANALYSIS_MARKETING_DISPLAY_AD_NETWORKS,
    WEBSITE_ANALYSIS_MARKETING_SOCIAL_OVERVIEW,
];

export const SI_ANALYSIS_TAB_ROUTES_SET = new Set<string>([
    ...SI_COMPANY_ANALYSIS_TAB_ROUTES,
    ...SI_WEBSITE_ANALYSIS_TAB_ROUTES,
]);

export const ACCOUNT_OVERVIEW_COMPANY = `${SI_ROOT_ROUTE}-account-overview-company`;
export const ACCOUNT_OVERVIEW_CONTACTS = `${SI_ROOT_ROUTE}-account-overview-contacts`;
export const ACCOUNT_OVERVIEW_HOME = `${SI_ROOT_ROUTE}-account-overview-home`;
export const ACCOUNT_REVIEW_ROOT = `accountreview-root`;
export const APP_CATEGORY_LEADERBOARD = "appcategory-leaderboard";
export const APP_CATEGORY_TRENDS = "appcategory-trends";

export const AI_AGENT_MEETING_ROOT = `${SI_ROOT_ROUTE}-ai-agent-meeting`;
export const AI_AGENT_MEETING = `${AI_AGENT_MEETING_ROOT}-id`;
export const AI_AGENT_MEETING_LATEST = `${AI_AGENT_MEETING_ROOT}-latest`;
export const AI_AGENT_EMAIL = `${SI_ROOT_ROUTE}-ai-agent-email`;
export const AI_SUPER_AGENT = `${SI_ROOT_ROUTE}-ai-super-agent`;

// new Find Apps feature
export const FIND_APPS_ABSTRACT_ROUTE = "salesIntelligence-findApps-abstract";
export const FIND_APPS_SEARCH_PAGE_ROUTE = `${SI_ROOT_ROUTE}-findApps-newSearch`;
// ------------------
export const FIND_LEADS_SEARCH_ROUTE = "salesIntelligence-advancedSearch-newSearch";

export const FIND_LEADS_SAVED_SEARCH_ROUTE = "salesIntelligence-advancedSearch-savedSearch";
export const FIND_LEADS_SAVED_SEARCH_ABSTRACT_ROUTE = "salesIntelligence-advancedSearch-abstract";

/* ---- ACCOUNT REVIEW ROUTES ---- */

export const ACCOUNT_REVIEW_TECHNOLOGIES_ROUTE = `accountreview_website_technologies`;

/* ---- Page URL's ---- */

export const SI_ROOT_ROUTE_URL = "/sales";

export const MY_LISTS_BASE_ROUTE_URL = "/lists";

export const CRM_LIST_NEW_PAGE_ROUTE_URL = "/crm-lists";

export const ENRICHMENT_PAGE_ROUTE_URL = "/enrichment";

export const SCORE_SETTINGS_PAGE_ROUTE_URL = "/score-settings";

export const DOWNLOAD_EXTENSION_PAGE_ROUTE_URL = "/download-extension";

export const PREMIUM_FEATURES_PAGE_ROUTE_URL = "/premium-features";

export const FIND_LEADS_PAGE_ROUTE_URL = "/find-leads";
// `filtersPayload` is the single slot for deep-linked filter values; `siteTags` and `industry` are
// deprecated single-filter aliases kept readable for links minted before it existed.
export const FIND_LEADS_SEARCH_ROUTE_URL = `${FIND_LEADS_PAGE_ROUTE_URL}/advanced-search?findNewProspects&signalId&isShowSavedSearchList&filtersPayload&siteTags&industry&${SEARCH_COMMON_URL_PARAMS}`;

export const FIND_APPS_PAGE_ROUTE_URL = "/find-apps";

export const AI_MEETING_AGENT_BASE_ROUTE_URL = "/ai-meeting-agent";
export const AI_MEETING_AGENT_PAGE_ROUTE_URL = `${AI_MEETING_AGENT_BASE_ROUTE_URL}?agentSettingsOpen`;
export const AI_MEETING_AGENT_CHAT_PAGE_ROUTE_URL = `${AI_MEETING_AGENT_BASE_ROUTE_URL}/chat/:domain?id&attendee&agentSettingsOpen&messageId&pdf`;
export const AI_MEETING_AGENT_LATEST_CHAT_PAGE_ROUTE_URL = `${AI_MEETING_AGENT_BASE_ROUTE_URL}/chat/latest/:domain?attendee`;

export const AI_EMAIL_AGENT_BASE_ROUTE_URL = "/ai-email-agent";
export const AI_AGENT_EMAIL_PAGE_ROUTE_URL = `${AI_EMAIL_AGENT_BASE_ROUTE_URL}?domain&recipient&agentSettingsOpen&autogenerate`;

export const AI_SUPER_AGENT_CHAT_PAGE_ROUTE_URL = "/ai-super-agent?id&agentSettingsOpen";

export const SI_MANAGEMENT_ROOT_URL = "/management";

export const MANAGEMENT_LIST_ROUTE_URL = `${SI_MANAGEMENT_ROOT_URL}?isScrollToIntegrationSection`;
export const ACCOUNT_SIGNALS_MANAGEMENT_PAGE_URL = `${SI_MANAGEMENT_ROOT_URL}/signals`;

export const INTENT_SIGNALS_MANAGEMENT_PAGE_URL = `${ACCOUNT_SIGNALS_MANAGEMENT_PAGE_URL}/intent`;
export const INTENT_SIGNALS_MANAGEMENT_INTRO_PAGE_URL = `${ACCOUNT_SIGNALS_MANAGEMENT_PAGE_URL}/intent/intro`;
export const STATIC_LIST_PAGE_ROUTE_URL = `${MY_LISTS_BASE_ROUTE_URL}/static/:id?isRecent&${SIGNAL_URL_PARAMS_WITH_ID}&${SEARCH_COMMON_URL_PARAMS}`;
export const MY_LISTS_PAGE_ROUTE_URL = "/lists?openAddList";
export const SAVE_SEARCH_RELATIVE_ROUTE_URL = `/:savedSearchId?isNewOnly&${SIGNAL_URL_PARAMS}&isShowWalkThrough`;
export const CRM_LIST_PAGE_ROUTE_URL = `${MY_LISTS_BASE_ROUTE_URL}/crm/{crm:salesforce|hubspot}/{objectType:accounts|leads|contacts}?${SIGNAL_URL_PARAMS_WITH_ID}`;

export const CONTACTS_WATERFALL_PAGE_ROUTE = `${SI_ROOT_ROUTE}-contacts-waterfall`;
export const CONTACTS_WATERFALL_PAGE_ROUTE_URL = "/contacts-waterfall";

export const EMPLOYEE_PROFILES_PAGE_ROUTE = `${SI_ROOT_ROUTE}-employee-profiles`;
export const EMPLOYEE_PROFILES_PAGE_ROUTE_URL = "/employee-profiles";

export const COMPANY_ANALYSIS_PAGE_ROUTE_URL = "/account-overview";
export const WEBSITE_ANALYSIS_PAGE_ROUTE_URL = "/account-review";
